import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as adminAccountActions from "../store/actions/admin_analytics_actions";
import { Row } from 'react-bootstrap';
import SummaryCard from "../components/summary-card";

const toCamelCase = (str) => {
  return str.replace(/^[a-z]/, (firstLetter) => firstLetter.toUpperCase());
};

export default function AdminAnalytics() {
  const [groupData, setGroupData] = React.useState({});

  const accountsSummaryCount = useSelector((state) => state.adminAnalytics.accountsSummaryCount);
  const groupWiseAccountsCount = useSelector((state) => state.adminAnalytics.groupWiseAccountsCount);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(adminAccountActions.getAccountsSummaryCountRequest());
    dispatch(adminAccountActions.getGroupWiseAccountsCountRequest());
  }, [dispatch]);

  useEffect(() => {
    if (!groupWiseAccountsCount.data) return;
    if (!groupWiseAccountsCount.data.data) return;

    setGroupData(groupWiseAccountsCount.data.data);

  }, [groupWiseAccountsCount.data])

  const summaryData = [
    { title: "Free Trial Accounts", count: accountsSummaryCount.data?.freeTrialAccountsCount },
    { title: "Free Accounts Count", count: accountsSummaryCount.data?.freeAccountsCount },
    { title: "Active Subscription Users", count: accountsSummaryCount.data?.activeSubscriptionUsersCount },
  ];
  const activeAccounts = [
    { title: "Today's Active Accounts", count: accountsSummaryCount.data?.todayActiveAccountsCount },
    { title: "Last Week's Active Accounts", count: accountsSummaryCount.data?.lastWeekActiveAccountsCount },
    { title: "Last Month's Active Accounts", count: accountsSummaryCount.data?.lastMonthActiveAccountsCount },
  ]

  return (
    <div className="container mt-4 mb-4">
      <h2 className="mb-4">Active Accounts</h2>
      <Row className="mb-8">
        {activeAccounts.map((data, index) => (
          <SummaryCard key={index} title={data.title} count={data.count} />
        ))}
      </Row>

      <h2 className="mb-4">Accounts Main Plans</h2>
      <Row>
        {summaryData.map((data, index) => (
          <SummaryCard key={index} title={data.title} count={data.count} />
        ))}
      </Row>

      {/* Group-Wise Accounts Count Section in a Card */}
      <h2 className="mb-4 text-center mt-8">Group Specific Accounts</h2>
      <h5 className="mb-4">Marketing</h5>
      <Row className="mb-8">
        {groupData.MARKETING && Object.keys(groupData.MARKETING).map((plan) => (
          <SummaryCard key={plan} title={toCamelCase(plan)} count={groupData.MARKETING[plan]} />
        ))}
      </Row>

      <h5 className="mb-4">XCRM</h5>
      <Row className="mb-8">
        {groupData.SALES && Object.keys(groupData.SALES).map((plan) => (
          <SummaryCard key={plan} title={toCamelCase(plan)} count={groupData.SALES[plan]} />
        ))}
      </Row>

      <h5 className="mb-4">ONE - Marketing + XCRM</h5>
      <Row className="mb-8">
        {groupData.SUITE && Object.keys(groupData.SUITE).map((plan) => (
          <SummaryCard key={plan} title={toCamelCase(plan)} count={groupData.SUITE[plan]} />
        ))}
      </Row>

      <h5 className="mb-4">GrandFathered</h5>
      <Row className="mb-8">
        {groupData.GRANDFATHERED && Object.keys(groupData.GRANDFATHERED).map((plan) => (
          <SummaryCard key={plan} title={toCamelCase(plan)} count={groupData.GRANDFATHERED[plan]} />
        ))}
      </Row>
    </div>
  );
}
